export default class Time extends EventTarget {

    constructor() {
        super()

        this.experience = new Experience();
        this.eventBus = this.experience.eventBus;

        this.start = this.now()
        this.current = this.start
        this.elapsed = 0
        this.delta = 16
        this.running = true
        this.directUpdates = [];
        this.request = null;

        this.focusCallback = () => {
            if (!this.running) return;
            this.loop();
        };
        window.addEventListener('focus', this.focusCallback);
        this.loop();
    }

    start() {
        if (this.running) return;
        this.running = true;
        this.loop();
    }

    stop() {
        this.running = false;
        if (this.request) {
            window.cancelAnimationFrame(this.request);
            this.request = null;
        }
    }

    tick() {
        if (this.request) return;
        this.request = window.requestAnimationFrame(() => this.update());
    }

    registerUpdate(callback) {
        this.directUpdates.push(callback);
    }

    update() {
        const currentTime = this.now();
        this.delta = currentTime - this.current;
        this.current = currentTime;
        this.directUpdates.forEach(callback => callback(this.delta));
        this.eventBus.pushLocal('update', { delta: this.delta });
    }

    now() {
        return performance.now();
    }

    loop() {
        if (!this.running || this.request) return;
        this.request = window.requestAnimationFrame(() => {
            this.request = null;
            this.update()
            this.loop()
        });
    }

    destroy() {
        this.stop();
        window.removeEventListener('focus', this.focusCallback);
    }
}
